<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoaded" class="row">
            <LoadingScreen :message="'Cargando información del usuario en el proyecto seleccionado...'" />
        </div>
        <div v-if="isLoaded" class="row">
            <div class="col-lg-12">
                <!-- Header Card -->
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="mb-1">Detalles de Horas en Proyecto:</h5>
                            </div>
                            <button class="btn btn-warning mb-0" @click="goBack">
                                <i class="fas fa-arrow-left me-2"></i>Volver
                            </button>
                        </div>
                        <!-- Información de la semana -->
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="d-flex flex-column gap-2">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-calendar-alt text-warning me-2"></i>
                                        <span>Semana: <b>{{ formatShortDate(startDate) }}</b> a <b>{{
                                            formatShortDate(endDate) }}</b></span>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-user text-warning me-2"></i>
                                        <span>Colaborador: <b>{{ name }}</b></span>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-project-diagram text-warning me-2"></i>
                                        <span>Proyecto: <b>{{ projectName }}</b></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contenido Principal -->
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoaded">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h5>Registros por autorizar:</h5>
                                </div>

                                <div>
                                    <button v-if="selectedRecords.length === 0" class="btn btn-success mb-0"
                                        @click="authAll">
                                        <i class="fas fa-check"></i> Autorizar Todo
                                    </button>
                                    <button v-if="selectedRecords.length > 0" class="btn btn-success mb-0"
                                        @click="authSelection">
                                        <i class="fas fa-check"></i> Autorizar Selección ({{ selectedRecords.length
                                        }})
                                    </button>
                                </div>
                            </div>

                            <div class="d-flex mt-2">
                                <div>
                                    <b><span class="badge badge-warning">{{ notAuthWeekStats.total_hours.toFixed(1)
                                    }}
                                            hrs
                                            Totales</span></b>
                                </div>
                                <div>
                                    <b><span class="badge badge-success ms-1">{{
                                        notAuthWeekStats.regular_hours.toFixed(1) }} hrs
                                            Regulares</span></b>
                                </div>
                                <div>
                                    <b><span class="badge badge-danger ms-1">{{
                                        notAuthWeekStats.extra_hours.toFixed(1)
                                            }} hrs
                                            Extra</span></b>
                                </div>
                            </div>


                            <!-- Tabla de registros por autorizar -->
                            <div class="row mt-4">
                                <div class="table-responsive">
                                    <table class="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input type="checkbox" @change="toggleSelectAll"
                                                        :checked="isAllSelected"
                                                        class="form-check-input border border-secondary">

                                                </th>
                                                <th>Fecha</th>
                                                <th>Actividad</th>
                                                <th>Horas</th>
                                                <th>Acciones</th>
                                                <th>Tiempo</th>
                                                <th>En planta?</th>
                                                <th>Notas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="!projectUserRecords.length">
                                                <td colspan="8" class="py-5">
                                                    <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                    <p class="text-muted mb-0">No hay registros sin autorizar para este
                                                        período</p>
                                                </td>
                                            </tr>
                                            <tr v-for="(record, idx) in projectUserRecords" :key="idx">
                                                <td>
                                                    <input type="checkbox" :value="record.time_record_id"
                                                        v-model="selectedRecords"
                                                        class="form-check-input border border-secondary">
                                                </td>
                                                <td>{{ formatShortDate(formatToLocalYMD(record.date)) }}</td>
                                                <td :class="record.is_billable ? 'bg-success text-white' : ''">
                                                    {{ record.activity }} - {{ record.description }}
                                                </td>
                                                <td><b>{{ record.total_hours }}</b></td>
                                                <td>
                                                    <button class="btn btn-success mb-0"
                                                        @click="authSingleRecord(record.time_record_id)">
                                                        <i class="fas fa-check"></i>
                                                    </button>
                                                    <button class="btn btn-warning mb-0 ms-2"
                                                        @click="editRecord(record.time_record_id)">
                                                        <i class="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button class="btn btn-danger mb-0 ms-2"
                                                        @click="deleteRecord(record.time_record_id)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                                <td :class="record.is_extra_time ? 'bg-warning text-white' : ''">
                                                    {{ record.is_extra_time ? 'EXTRA' : 'REGULAR' }}
                                                </td>
                                                <td>
                                                    {{ record.on_site ? 'SI' : 'NO' }}
                                                </td>
                                                <td>
                                                    {{ record.notes }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- Resumen de horas 
                            <div v-if="projectUserRecords.length" class="row mt-4">
                                <div class="col-md-4">
                                    <div class="card bg-gradient-primary">
                                        <div class="card-body p-3">
                                            <div class="text-white">
                                                <h6 class="text-white mb-0">Total Horas</h6>
                                                <h3 class="text-white mb-0">{{ totalHours }} hrs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card bg-gradient-success">
                                        <div class="card-body p-3">
                                            <div class="text-white">
                                                <h6 class="text-white mb-0">Horas Facturables</h6>
                                                <h3 class="text-white mb-0">{{ billableHours }} hrs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card bg-gradient-warning">
                                        <div class="card-body p-3">
                                            <div class="text-white">
                                                <h6 class="text-white mb-0">Horas Extra</h6>
                                                <h3 class="text-white mb-0">{{ extraHours }} hrs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            -->
                        </div>
                    </div>
                </div>

                <!-- Contenido Principal -->
                <div class="card mt-4">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-8">
                                <div>
                                    <h5>Registros autorizados:</h5>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Tabla de registros autorizados -->
                            <div class="table-responsive">
                                <table class="table table-bordered text-center align-middle">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Actividad</th>
                                            <th>Horas</th>
                                            <th>Tiempo</th>
                                            <th>En planta?</th>
                                            <th>Notas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!projectUserAuthRecords.length">
                                            <td colspan="6" class="py-5">
                                                <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                <p class="text-muted mb-0">No hay registros autorizados para este
                                                    período</p>
                                            </td>
                                        </tr>
                                        <tr v-for="(tr, idx) in projectUserAuthRecords" :key="idx">
                                            <td>{{ formatShortDate(formatToLocalYMD(tr.date)) }}</td>
                                            <td>
                                                {{ tr.activity }} - {{ tr.description }}
                                            </td>
                                            <td><b>{{ tr.total_hours }}</b></td>
                                            <td :class="tr.is_extra_time ? 'bg-warning text-white' : ''">
                                                {{ tr.is_extra_time ? 'EXTRA' : 'REGULAR' }}
                                            </td>
                                            <td>
                                                {{ tr.on_site ? 'SI' : 'NO' }}
                                            </td>
                                            <td>
                                                {{ tr.notes }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData2" @close="closeModal">
    </Modal>
</template>

<script setup>
import { ref, onMounted, shallowRef, computed } from "vue"
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import LoadingScreen from "./components/LoadingScreen.vue"

const route = useRoute()
const router = useRouter()
const token = localStorage.getItem('authToken')
const API_BASE_URL = process.env.VUE_APP_BASE_URL

// RECIBIR PARÁMETROS DESDE QUERY PARAMS

const user_id = ref(route.query.user_id)
const project_id = ref(route.query.project_id)
const startDate = ref(route.query.start_date)
const endDate = ref(route.query.end_date)
const name = ref(route.query.name || '')
const projectName = ref(route.query.project || '')

// Selección de registros
const selectedRecords = ref([])

const isAllSelected = computed(() => {
    return projectUserRecords.value.length > 0 &&
        selectedRecords.value.length === projectUserRecords.value.length
})

// Función para seleccionar/deseleccionar todos
const toggleSelectAll = () => {
    if (isAllSelected.value) {
        selectedRecords.value = []
    } else {
        selectedRecords.value = projectUserRecords.value.map(tr => tr.time_record_id)
    }
}


// MODAL

import Modal from "./components/Modal.vue"
import PMEditTimeRecord from "./components/forms/PMEditTimeRecord.vue"
const isModalOpen = ref(false)
const selectedFormComponent = shallowRef(null)
const modalTitle = ref("")
const selectedData2 = ref(null)
const formComponents = { PMEditTimeRecord: PMEditTimeRecord }

const openModal = (data, formType) => {
    selectedData2.value = data || {}
    selectedFormComponent.value = formComponents[formType] || null

    const titles = {
        PMEditTimeRecord: 'Editar Registro de Tiempo',
    }
    modalTitle.value = titles[formType] || "Editar Información"
    isModalOpen.value = true
}

const closeModal = () => {
    isModalOpen.value = false
}

const notAuthWeekStats = ref({
    total_hours: 0,
    regular_hours: 0,
    extra_hours: 0,
})


// DATOS Y ESTADO
const projectUserRecords = ref([])
const projectUserAuthRecords = ref([])
const isLoaded = ref(false)


// FUNCIONES DE FORMATO

const formatShortDate = (dateYMD) => {
    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
    const months = ['Enero', 'Feb', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Sept', 'Oct', 'Nov', 'Dic']

    const [year, month, day] = dateYMD.split('-').map(Number)
    const date = new Date(year, month - 1, day)

    const weekDay = days[date.getDay()]
    const day2 = date.getDate()
    const month2 = months[date.getMonth()]

    return `${weekDay} ${day2} ${month2}`
}

const formatToLocalYMD = (date) => {
    const d = new Date(date)
    if (isNaN(d.getTime())) return ''

    d.setDate(d.getDate() + 1)
    return d.toLocaleDateString('sv-SE')
}

// FUNCIONES DE API

const getWeekNotAuthRecords = async () => {
    const body = {
        user_id: user_id.value,
        start_date: startDate.value,
        end_date: endDate.value,
        project_id: project_id.value
    }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/project-user-not-auth-tr-details`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            projectUserRecords.value = response.data.data
            notAuthWeekStats.value = response.data.stats
        } else {
            console.error('Error al obtener los registros de tiempo')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}

const getWeekAuthRecords = async () => {
    const body = {
        user_id: user_id.value,
        start_date: startDate.value,
        end_date: endDate.value,
        project_id: project_id.value
    }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/project-user-auth-tr-details`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            projectUserAuthRecords.value = response.data
        } else {
            console.error('Error al obtener los registros de tiempo')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}

const getData = async () => {
    await getWeekNotAuthRecords();
    await getWeekAuthRecords();
    isLoaded.value = true;
}


// ACCIONES

const goBack = () => {
    router.go(-1)
}

const editRecord = async (id) => {
    const data = { time_record_id: id }
    openModal(data, 'PMEditTimeRecord')
}

const deleteRecord = async (id) => {
    if (!confirm('¿Seguro que deseas eliminar este registro del usuario?')) {
        return
    }

    const body = { time_record_id: id }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/remove-time-record`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            alert('Registro eliminado')
            await getData()
        } else {
            console.error('Error al eliminar el registro')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}

const authAll = async () => {

    let message = '¿Seguro que deseas autorizar todos los registros de este usuario en el proyecto seleccionado? Esta acción NO puede deshacerse.'

    if (!confirm(message)) { return; }

    selectedRecords.value = projectUserRecords.value.map(tr => tr.time_record_id)

    const body = { ids: selectedRecords.value }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/auth-project-time-records`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            alert(response.data.msg)
            await getData()
            selectedRecords.value = []
        } else {
            console.error('Error al eliminar el registro')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}

const authSelection = async () => {
    let message = '¿Seguro que deseas autorizar los registros seleccionados de este usuario en el proyecto seleccionado? Esta acción NO puede deshacerse.'

    if (!confirm(message)) { return; }

    const body = { ids: selectedRecords.value }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/auth-project-time-records`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            alert(response.data.msg)
            await getData();
            selectedRecords.value = []
        } else {
            console.error('Error al eliminar el registro')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}

const authSingleRecord = async (id) => {

    let message = '¿Seguro que deseas autorizar este registro del usuario en el proyecto seleccionado? Esta acción NO puede deshacerse.'

    if (!confirm(message)) { return; }

    const body = { time_record_id: id }

    try {
        const response = await axios.post(
            `${API_BASE_URL}/auth-project-time-records`,
            body,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )

        if (response.status === 200) {
            alert(response.data.msg)
            await getData();
        } else {
            console.error('Error al eliminar el registro')
        }
    } catch (error) {
        console.error('Error en la solicitud de la API:', error)
    }
}


onMounted(async () => {
    await getData();
})
</script>

<style scoped>
.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.gap-2 {
    gap: 0.5rem;
}

.bg-gradient-primary {
    background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%);
}

.bg-gradient-success {
    background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%);
}

.bg-gradient-warning {
    background: linear-gradient(87deg, #fb6340 0, #fbb140 100%);
}
</style>